import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import api from "../../../../store/api";
import { AppThunk } from "../../../../store/app";
import Config from "../../../../config/Config";
import { dateCompare } from "../../../../config/Global";
import { apiUrls } from "./apiUrls";

interface InitialState {
  isLoading: boolean;
  agGrid: any;
  accessCodesAgGrid: any;
  rowData: any;
  perPage: any;
  details: any;
  exportId: any;
}

const initialState = {
  isLoading: false,
  agGrid: null,
  accessCodesAgGrid: null,
  rowData: null,

  perPage: Config.grid.server.gridOptions?.paginationPageSize,
  details: {
    id: null,
    company_id: null,
    campaign_name: null,
    start_date: null,
    end_date: null,
    short_code: null,
    access_code_count: null,
    status: null,
    special_flag: null,
    industry_id: null,
    created_at: null,
    categories: [],
    access_codes: [],
    company: [],
    industry: []
  },
  exportId: null
} as InitialState;

const customerAccessSlice = createSlice({
  name: "customerAccess",
  initialState,
  reducers: {
    start: state => {
      state.isLoading = true;
    },
    success: state => {
      state.isLoading = false;
    },
    failure: state => {
      state.isLoading = false;
    },
    setGrid: (state, action: PayloadAction<any>) => {
      state.agGrid = action?.payload;
    },
    setAccessCodesGrid: (state, action: PayloadAction<any>) => {
      state.accessCodesAgGrid = action?.payload;
    },
    setRowData: (state, action: PayloadAction<any>) => {
      state.rowData = action?.payload;
    },
    setPerPage: (state, action: PayloadAction<any>) => {
      state.perPage = action?.payload;
      if (state.agGrid) {
        state.agGrid.api.paginationSetPageSize(Number(state.perPage));
        state.agGrid.api.setCacheBlockSize(state.perPage);
      }
    },
    setDetails: (state, action: PayloadAction<any>) => {
      state.details = action?.payload;
    },
    setExportId: (state, action: PayloadAction<any>) => {
      state.exportId = action?.payload;
    },
  },
});

export const {
  start,
  success,
  failure,
  setRowData,
  setGrid,
  setAccessCodesGrid,
  setPerPage,
  setDetails,
} = customerAccessSlice.actions;

/** For Listing:Start */
export const fetchList =
  (): AppThunk<any> =>
    async dispatch => {
      try {
        dispatch(start());
        dispatch(setRowData([]));
        const response = await api.get(apiUrls.list);
        const modifiedData = response.data.rows.map((row: any) => {

          // if (row.special_flag == 2) {
          //   row.is_completed = 'Running';
          //   // row.start_date = false;
          //   // row.end_date = false;
          // }
          // else
          // {
          //   // row.role_id = row.is_completed == 'Completed' ? 1 : 2
          // }
          row.is_completed = dateCompare(row.end_date) != 1 ? 'Completed' : 'Running';
          return row;
        });
        dispatch(setRowData(modifiedData));
        dispatch(success());
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(failure());
        return Promise.reject(error.data);
      }
    };
/** For Listing:End */

export const setPerPageSize =
  (size: number): AppThunk<any> =>
    async dispatch => {
      dispatch(setPerPage(size));
      dispatch(fetchList());
    };

//** For curd operations:Start */
export const createRecord =
  (action: any): AppThunk<any> =>
    async dispatch => {
      try {
        dispatch(start());
        const response = await api.post(apiUrls.create, action);
        dispatch(success(response.data));
        dispatch(fetchList());
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(failure(error.data));
        return Promise.reject(error.data);
      }
    };

export const updateRecord =
  (id: number, action: any): AppThunk<any> =>
    async dispatch => {
      try {
        dispatch(start());
        const response = await api.post(apiUrls.update(id), action);
        dispatch(success(response.data));
        dispatch(fetchList());
        return Promise.resolve(response.data);
      } catch (error: any) {
        dispatch(failure(error.data));
        return Promise.reject(error.data);
      }
    };


export const details =
  (id: number): AppThunk<any> =>
    async dispatch => {
      try {
        const response = await api.get(apiUrls.details(id));
        var modifiedData = response.data.data;
        // if (modifiedData.special_flag == 2) {
        //   modifiedData.is_completed = 'Running';
        //   // modifiedData.start_date = false;
        //   // modifiedData.end_date = false;
        // }
        // else
        // {
        //   // row.role_id = row.is_completed == 'Completed' ? 1 : 2
        // }
        modifiedData.is_completed = dateCompare(modifiedData.end_date) != 1 ? 'Completed' : 'Running';
        modifiedData.access_codes = modifiedData.access_codes.map((row: any) => {
          return { ...row, special_flag: modifiedData.special_flag };
        });
        // modifiedData.is_completed = dateCompare(modifiedData.end_date) != 1 ? 'Completed' : 'Running';
        console.log('modifiedData',modifiedData)
        dispatch(setDetails(modifiedData));
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };

export const changeStatus =
  (id: number, status: number): AppThunk<any> =>
    async dispatch => {
      try {
        const response = await api.post(apiUrls.changeStatus(id), { status });
        dispatch(fetchList());
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };


export const exportFile =
  (id: number): AppThunk<any> =>
    async dispatch => {
      try {
        const response = await api.get(apiUrls.export(id));
        dispatch(success(response.data));
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };


export const customerAccessCampaignList =
  (): AppThunk<any> =>
    async dispatch => {
      try {
        const response = await api.get(apiUrls.customerAccessList);
        dispatch(success(response.data));
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };



export const customerAccessIndustryList =
  (customer_id: number): AppThunk<any> =>
    async dispatch => {
      try {
        const response = await api.get(apiUrls.getIndustry(customer_id));
        return Promise.resolve(response.data);
      } catch (error: any) {
        return Promise.reject(error.data);
      }
    };




const customerAccessReducer = customerAccessSlice.reducer;
export default customerAccessReducer;
